// components
import { Box, Collapse } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

// types
import type { KidsRatioResponse } from 'generated';
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

type StatusKey = 'neutral' | 'success' | 'error' | 'forbidden';
const STATUS: {
  COLORS: Record<StatusKey, string>;
  ICONS: Record<StatusKey, IconType>;
} = {
  COLORS: {
    neutral: '#CBEDF9',
    success: '#92CF56',
    error: '#F3B3B2',
    forbidden: '#F3B3B2'
  },
  ICONS: {
    neutral: 'arrow-down' as IconType,
    success: 'check' as IconType,
    error: 'triangle-exclamation' as IconType,
    forbidden: 'ban' as IconType
  }
};

export default function StatusBlock({
  expanded,
  ratio
}: {
  ratio: KidsRatioResponse | undefined;
  expanded: boolean;
}) {
  const balance = ratio?.employeeBalance;
  const status =
    balance === 0
      ? 'success'
      : !balance
      ? 'forbidden'
      : balance > 0
      ? 'neutral'
      : 'error';

  return (
    <Box
      flex="1"
      sx={{
        display: 'grid',
        placeItems: 'center'
      }}
      textAlign="center"
      bgcolor={STATUS.COLORS[status]}
      py={1}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
      >
        <Icon
          type={STATUS.ICONS[status]}
          sx={{ flex: 1, paddingLeft: '15px' }}
          fontSize="small"
        />
        <Box flex={1} sx={{ paddingRight: '15px' }}>
          {ratio?.kidDistribution?.total ?? 0}
        </Box>
      </Box>
      <Collapse in={expanded}>
        <Box mt={1} fontSize="14px">
          {balance ?? '-'}
        </Box>
      </Collapse>
    </Box>
  );
}
